import { Guarantee } from '@/constants/guarantee';

export function GuaranteeCard() {
  return (
    <div className="rounded-xl bg-graphite p-6 text-paper sm:p-8">
      <h2 className="text-xl font-bold">{Guarantee.title}</h2>
      <p className="mt-1 leading-relaxed text-paper/75">{Guarantee.tagline}</p>
      <ul className="mt-6 space-y-5">
        {Guarantee.promises.map((promise) => {
          const PromiseIcon = promise.icon;
          return (
            <li key={promise.id} className="flex gap-3">
              <PromiseIcon aria-hidden="true" className="mt-0.5 size-5 shrink-0 text-pad" />
              <div>
                <h3 className="font-semibold">{promise.title}</h3>
                <p className="mt-1 text-[0.9375rem] leading-relaxed text-paper/75">{promise.description}</p>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}